import Radio from 'backbone.radio';
import ChangeAccountDetailView from '@/views/dialogs/change_account_details';
    var globalCh = Radio.channel('global');

    export default function show_change_account_details(primary) {
        var view = new ChangeAccountDetailView({
            model: primary
        });
        globalCh.request('showDialog', view);
    }

